module.exports = __webpack_public_path__ + "static/media/services-submenu-tech-testing.3c1fd743.png";